"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TwoPanelSettingsModal = void 0;
var react_1 = __importStar(require("react"));
var inversify_react_1 = require("inversify-react");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var ModalComponent_1 = __importDefault(require("@CommonFrontend/Modal/ModalComponent"));
var BemBuilder_1 = __importDefault(require("@CommonFrontend/Utils/BemBuilder"));
var Configuration_1 = require("@CommonFrontend/Styles/Configuration/Configuration");
var c = (0, BemBuilder_1.default)("two-panel-settings-modal");
function TwoPanelSettingsModal(_a) {
    var _this = this;
    var onClose = _a.onClose, onApply = _a.onApply, hasUnsavedChanges = _a.hasUnsavedChanges, hasValidInputs = _a.hasValidInputs, itemNoun = _a.itemNoun, isNew = _a.isNew, right = _a.right, left = _a.left, headerInfo = _a.headerInfo;
    var modalService = (0, inversify_react_1.useInjection)("modal");
    var _b = __read((0, react_1.useState)(false), 2), saveInProgress = _b[0], setSaveInProgress = _b[1];
    var onApplyHandler = function () { return __awaiter(_this, void 0, void 0, function () {
        var success;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setSaveInProgress(true);
                    return [4, onApply()];
                case 1:
                    success = _a.sent();
                    setSaveInProgress(false);
                    if (success)
                        onClose();
                    return [2];
            }
        });
    }); };
    var onCancel = function () { return __awaiter(_this, void 0, void 0, function () {
        var okToDiscard;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!hasUnsavedChanges()) return [3, 2];
                    return [4, modalService.showDeleteModal({
                            title: "Discard changes?",
                            explainer: "Changes you made to this ".concat(itemNoun, " haven\u2019t been saved. Keep editing to save the ").concat(itemNoun, "."),
                            cancelLabel: "Keep editing",
                            confirmLabel: "Discard",
                            isEscapable: true,
                        })];
                case 1:
                    okToDiscard = _a.sent();
                    if (!okToDiscard)
                        return [2];
                    _a.label = 2;
                case 2:
                    onClose();
                    return [2];
            }
        });
    }); };
    var saveDisabledReason = function () {
        if (!hasValidInputs()) {
            return "Complete the form to continue";
        }
        if (!isNew && !hasUnsavedChanges()) {
            return "Make some changes to save";
        }
        return "";
    };
    return (react_1.default.createElement(ModalComponent_1.default, { className: c(), containerClassName: c("container"), contentClassName: c("content") },
        react_1.default.createElement(kaleidoscope_1.Layer, { offset: Configuration_1.modalZIndex }, function () {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(kaleidoscope_1.Stack, { className: c("header"), align: "center", direction: "horizontal", justify: "spaceBetween" },
                    react_1.default.createElement(kaleidoscope_1.Stack, { align: "center", direction: "horizontal", gap: "l" },
                        react_1.default.createElement(kaleidoscope_1.Heading, { level: "4", strong: true },
                            isNew ? "New" : "Edit",
                            " ",
                            itemNoun)),
                    react_1.default.createElement(kaleidoscope_1.Stack, { align: "center", direction: "horizontal", gap: "l" },
                        headerInfo,
                        react_1.default.createElement(kaleidoscope_1.Tooltip, { show: saveDisabledReason() ? undefined : false, content: saveDisabledReason(), size: kaleidoscope_1.TooltipSize.Small, wrapTarget: true },
                            react_1.default.createElement(kaleidoscope_1.Button, { onClick: onApplyHandler, disabled: !!saveDisabledReason(), buttonState: saveInProgress ? kaleidoscope_1.ButtonState.Waiting : kaleidoscope_1.ButtonState.Idle }, isNew ? "Create" : "Apply")),
                        react_1.default.createElement(kaleidoscope_1.IconButton, { icon: react_1.default.createElement(icons_1.Close, null), onClick: onCancel, disabled: saveInProgress, buttonState: kaleidoscope_1.ButtonState.Idle }))),
                react_1.default.createElement("div", { className: c("left") }, left),
                react_1.default.createElement(kaleidoscope_1.Stack, { className: c("right"), align: "center" }, right)));
        })));
}
exports.TwoPanelSettingsModal = TwoPanelSettingsModal;
